export default __webpack_public_path__ + "static/accents-border-token-light-14553dabc07a4c6534ae3428ed6a69900cc50f11addb53cb75b1a3cea294d9b1.png";